var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image",attrs:{"title":_vm.name}},[_c('img',{attrs:{"src":_vm.picture || require('@/assets/location.png')},on:{"error":_vm.onInvalidImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }